export default __webpack_public_path__ + "static/media/kart.52c1572c.png";